import { type Bonus, type Entity, bonus } from '../entities';
import { buttonClick } from '../events';
import type { TrackingContextValue } from '../providers/TrackingContext';
import { GAEvent } from '../utils';

import { mergeWithTrackingContextValue } from './utils/mergeWithTrackingContextValue';

export const promotionRemoved = (context: TrackingContextValue, bonusDetail?: Bonus) => {
  if (bonusDetail) {
    const entities: Entity[] = [bonus(bonusDetail)];
    context = mergeWithTrackingContextValue(context, entities);
  }

  GAEvent({ action: 'Remove Promotion' }, context);
  buttonClick({ buttonName: 'Remove Promotion' }, context);
};
